import { render, staticRenderFns } from "./BtnOrder.vue?vue&type=template&id=4bec5254&scoped=true"
import script from "./BtnOrder.vue?vue&type=script&lang=js"
export * from "./BtnOrder.vue?vue&type=script&lang=js"
import style0 from "./BtnOrder.vue?vue&type=style&index=0&id=4bec5254&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bec5254",
  null
  
)

export default component.exports